export enum SessionActions {
  deleteSession = '[SESSION]:DELETE',
  setLoginRedirect = '[SESSION]:LOGIN.SET.REDIRECT',
  createAccountStart = '[SESSION]:CREATE_ACCOUNT:START',
  createAccountSuccess = '[SESSION]:CREATE_ACCOUNT:SUCCESS',
  createAccountError = '[SESSION]:CREATE_ACCOUNT:ERROR',
  getUserInfoStart = '[SESSION]:GET_USER_INFO:START',
  getUserInfoSuccess = '[SESSION]:GET_USER_INFO:SUCCESS',
  getUserInfoError = '[SESSION]:GET_USER_INFO:ERROR',
  pinLoginStart = '[SESSION]:PIN_LOGIN:START',
  pinLoginSuccess = '[SESSION]:PIN_LOGIN:SUCCESS',
  pinLoginError = '[SESSION]:PIN_LOGIN:ERROR',
}
